module.exports = "https://cdn.hellotech.com/client-assets/printers_desktop_d71707619331175b6a5d32fac4d7f645.webp";